import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import "../CSS/Misafir_Oda.css"
import loading_ from "../../Assets2/loading.gif";

import { connect } from 'react-redux'
import * as XLSX from 'xlsx';
import axiosInstance from '../../services/axiosConfig';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale
} from 'chart.js';
import 'chartjs-adapter-moment';

// Register ChartJS components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    TimeScale
);

const Misafir_oda_izleme = (props) => {


    const history = useHistory();

    const [state, Set_state] = useState([])

    const [date1, Setdate1] = useState("")
    const [date2, Setdate2] = useState("")

    const [active_number, Set_active_number] = useState(1)
    const [items_per_page, Set_items_per_page] = useState(5)

    const [control_loading, Set_control_loading] = useState(false)


    const [render_state, Set_render_state] = useState([])

    const [current_edit_data, Set_current_edit_data] = useState({})

    const onChangeEditM = (e) => {
        const { name, value } = e.target;
        Set_current_edit_data((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Set default dates to last month
    useEffect(() => {
        const today = new Date();
        const lastMonth = new Date(today);
        lastMonth.setMonth(today.getMonth() - 1);

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        Setdate1(formatDate(lastMonth));
        Setdate2(formatDate(today));
    }, []);

    useEffect(() => {
        const componentDidMount = async () => {
            try {
                const req_ = await axiosInstance.post("/tags/GetMisafirOdaAll", {
                    companyId: String(props.temp_com_id)
                })

                let new_data = [];

                const response = req_.data
                console.log(response);
                new_data = response


                new_data.sort((a, b) => {
                    // Date objeleri oluştur
                    let dateA = new Date(a.date);
                    let dateB = new Date(b.date);

                    // Karşılaştırma yaparak sıralama
                    return dateA - dateB;
                });
                console.log(new_data);
                Set_state(new_data)

            } catch (error) {
                console.log(error);
            }
        }

        componentDidMount()
    }, [])

    // Auto-load data when dates are set
    useEffect(() => {
        if (date1 && date2 && state.length > 0) {
            getElementsWithinDateRange(state, convertDateToMMDDYYYY(date1), convertDateToMMDDYYYY(date2));
        }
    }, [date1, date2, state]);


    const exportToExcel = () => {


        Set_control_loading(true)
        document.querySelector(".misaifr_oda_view_datas").classList.toggle("misaifr_oda_view_datas_blur")

        if (render_state.length > 0) {
            setTimeout(() => {
                const data = generateData(render_state);

                const wb = XLSX.utils.book_new();
                const ws = XLSX.utils.aoa_to_sheet(data);
                XLSX.utils.book_append_sheet(wb, ws, 'Data');

                XLSX.writeFile(wb, `Misafir-Oda ${convertTo24HourAndDMY(date1)}-${convertTo24HourAndDMY(date2)}.xlsx`);

                Set_control_loading(false)
                document.querySelector(".misaifr_oda_view_datas").classList.toggle("misaifr_oda_view_datas_blur")

            }, 2000);


        }

    };

    const generateData = (dataList) => {
        const data = [['Date', 'Next Date', 'Misafir', 'Oda']];

        for (let i = 0; i < dataList.length; i++) {
            const current = dataList[i];
            const next = i < dataList.length - 1 ? dataList[i + 1].date : "";
            data.push([convertTo24HourAndDMY(current.date), convertTo24HourAndDMY(next), current.misafir, current.oda]);
        }

        return data;
    };


    function getElementsWithinDateRange(dataList, startDate, endDate) {
        // Date objelerine dönüştür
        let start = new Date(startDate);
        let end = new Date(endDate);

        console.log(start, end, dataList);

        // Listeyi filtrele
        Set_render_state(dataList.filter(item => {
            let itemDate = new Date(item.date);
            console.log(itemDate);
            if (itemDate >= start && itemDate <= end) console.log(item.date);
            return itemDate >= start && itemDate <= end;
        }));
    }

    useEffect(() => { console.log(render_state); }, [render_state])

    function convertDateToMMDDYYYY(dateString) {
        // Tarihi parçalarına ayır
        let [year, month, day] = dateString.split('-');
        // MM/DD/YYYY formatına dönüştür ve döndür
        return `${month}/${day}/${year}`;
    }

    function clear() {
        Set_render_state([])
        const today = new Date();
        const lastMonth = new Date(today);
        lastMonth.setMonth(today.getMonth() - 1);

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        Setdate1(formatDate(lastMonth));
        Setdate2(formatDate(today));
        Set_active_number(1)
    }

    const totalPages = Math.ceil(render_state.length / items_per_page);

    const openPopUp = () => {
        document.querySelector(".edit-popUp-MOIzleme").classList.toggle("edit-popUp-MOIzleme_active")
        document.querySelector(".misaifr_oda_view_datas").classList.toggle("misaifr_oda_view_datas_dark")
    }


    const closePopUp = () => {
        document.querySelector(".edit-popUp-MOIzleme").classList.toggle("edit-popUp-MOIzleme_active")
        document.querySelector(".misaifr_oda_view_datas").classList.toggle("misaifr_oda_view_datas_dark")
        Set_current_edit_data({})

    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const pad = (num) => (num < 10 ? '0' + num : num);

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.000`;
    };

    const EditKaydet = async (e) => {
        e.preventDefault();

        let currentObj = current_edit_data;
        let date_ = currentObj.date

        date_ = formatDate(date_);

        try {
            const req_ = await axiosInstance.post("/tags/UpdateMisafirOda", {
                misafir: currentObj.misafir, oda: currentObj.oda, date: date_
            })

            const response = req_.data;

            if (req_.status === 200) {
                const componentDidMount = async () => {
                    try {
                        const req_ = await axiosInstance.post("/tags/GetMisafirOdaAll", {
                            companyId: String(props.temp_com_id)
                        })

                        let new_data = [];

                        const response = req_.data
                        new_data = response

                        new_data.sort((a, b) => {
                            // Date objeleri oluştur
                            let dateA = new Date(a.date);
                            let dateB = new Date(b.date);

                            // Karşılaştırma yaparak sıralama
                            return dateA - dateB;
                        });
                        console.log(new_data);
                        Set_state(new_data)

                        let start = new Date(convertDateToMMDDYYYY(date1));
                        let end = new Date(convertDateToMMDDYYYY(date2));


                        // Listeyi filtrele
                        Set_render_state(new_data.filter(item => {
                            let itemDate = new Date(item.date);
                            console.log(itemDate);
                            return itemDate >= start && itemDate <= end;
                        }));

                    } catch (error) {
                        console.log(error);
                    }
                }

                componentDidMount()
            }
        } catch (err) {
            console.log(err);
        } finally {
            document.querySelector(".edit-popUp-MOIzleme").classList.toggle("edit-popUp-MOIzleme_active")
            document.querySelector(".misaifr_oda_view_datas").classList.toggle("misaifr_oda_view_datas_dark")
            Set_current_edit_data({})
        }



    }

    function convertTo24HourAndDMY(dateStr) {
        // Convert the date string into a Date object
        const date = new Date(dateStr);

        // Get day, month, and year in DD/MM/YYYY format
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = date.getFullYear();

        // Get hours and minutes in 24-hour format
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Format the time in HH:mm:ss format
        const time24 = `${hours}:${minutes}:${seconds}`;

        // Format the date in DD/MM/YYYY format
        const formattedDate = `${day}/${month}/${year}`;

        return `${formattedDate} - ${time24}`
    }

    async function deleteData(date_) {

        try {
            let request = await axiosInstance.post("/tags/DeleteMO", {
                date: date_,
                companyId: String(props.temp_com_id)
            })

            let response = request.data;

            if (request.status === 200) {
                console.log(response);
            }


            const req_ = await axiosInstance.post("/tags/GetMisafirOdaAll", {
                companyId: String(props.temp_com_id)
            })

            let new_data = [];

            const response_ = req_.data
            console.log(response_);
            new_data = response_


            new_data.sort((a, b) => {
                // Date objeleri oluştur
                let dateA = new Date(a.date);
                let dateB = new Date(b.date);

                // Karşılaştırma yaparak sıralama
                return dateA - dateB;
            });
            console.log(new_data);
            Set_state(new_data)
            let start = new Date(convertDateToMMDDYYYY(date1));
            let end = new Date(convertDateToMMDDYYYY(date2));


            // Listeyi filtrele
            Set_render_state(new_data.filter(item => {
                let itemDate = new Date(item.date);
                console.log(itemDate);
                return itemDate >= start && itemDate <= end;
            }));
        } catch (err) {
            console.log(err);
        }


    }

    // Prepare chart data
    const chartData = {
        labels: render_state.map(item => new Date(item.date).toLocaleDateString('tr-TR')),
        datasets: [
            {
                label: 'Misafir Sayısı',
                data: render_state.map(item => item.misafir),
                borderColor: '#000000',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                borderWidth: 2,
                tension: 0.4,
                pointRadius: 4,
                pointHoverRadius: 6,
            },
            {
                label: 'Oda Sayısı',
                data: render_state.map(item => item.oda),
                borderColor: '#2563eb',
                backgroundColor: 'rgba(37, 99, 235, 0.1)',
                borderWidth: 2,
                tension: 0.4,
                pointRadius: 4,
                pointHoverRadius: 6,
            }
        ]
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    usePointStyle: true,
                    padding: 15,
                    font: {
                        size: 12,
                        weight: 'bold'
                    }
                }
            },
            title: {
                display: true,
                text: 'Misafir ve Oda Sayısı Trend Grafiği',
                font: {
                    size: 16,
                    weight: 'bold'
                },
                padding: {
                    top: 10,
                    bottom: 20
                }
            },
            tooltip: {
                mode: 'index',
                intersect: false,
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                padding: 12,
                titleFont: {
                    size: 14,
                    weight: 'bold'
                },
                bodyFont: {
                    size: 13
                },
                borderColor: '#ccc',
                borderWidth: 1
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    stepSize: 1,
                    font: {
                        size: 11
                    }
                },
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)'
                }
            },
            x: {
                ticks: {
                    maxRotation: 45,
                    minRotation: 45,
                    font: {
                        size: 10
                    }
                },
                grid: {
                    display: false
                }
            }
        },
        interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false
        }
    };

    return (
        <>
            {control_loading && <div className="export_loading_active">
                <img style={{ width: "40%", position: "relative", left: "30%" }} src={loading_} alt="" />
                <p style={{ textAlign: "center" }}>Çıktı Alınıyor...</p>

            </div >}
            <div className="edit-popUp-MOIzleme">
                <div style={{
                    backgroundColor: '#fff',
                    padding: '28px',
                    borderRadius: '12px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                    minWidth: '400px'
                }}>
                    <h2 style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1a1a1a',
                        marginBottom: '24px',
                        borderBottom: '3px solid #edbc45',
                        paddingBottom: '12px'
                    }}>Veri Düzenle</h2>

                    <div style={{
                        marginBottom: '20px'
                    }}>
                        <label style={{
                            display: 'block',
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#1a1a1a',
                            marginBottom: '8px'
                        }} htmlFor="misafir">Misafir Sayısı</label>
                        <input
                            onChange={onChangeEditM}
                            value={current_edit_data.misafir || ''}
                            name='misafir'
                            type="number"
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                fontSize: '15px',
                                border: '2px solid #e5e7eb',
                                borderRadius: '8px',
                                outline: 'none',
                                transition: 'all 0.3s',
                                fontWeight: '600'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#edbc45'}
                            onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                        />
                    </div>

                    <div style={{
                        marginBottom: '28px'
                    }}>
                        <label style={{
                            display: 'block',
                            fontSize: '14px',
                            fontWeight: '600',
                            color: '#1a1a1a',
                            marginBottom: '8px'
                        }} htmlFor="oda">Oda Sayısı</label>
                        <input
                            onChange={onChangeEditM}
                            value={current_edit_data.oda || ''}
                            name='oda'
                            type="number"
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                fontSize: '15px',
                                border: '2px solid #e5e7eb',
                                borderRadius: '8px',
                                outline: 'none',
                                transition: 'all 0.3s',
                                fontWeight: '600'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#edbc45'}
                            onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                        />
                    </div>

                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'flex-end'
                    }}>
                        <button
                            onClick={closePopUp}
                            style={{
                                padding: '12px 28px',
                                fontSize: '15px',
                                fontWeight: '600',
                                backgroundColor: '#fff',
                                color: '#1a1a1a',
                                border: '2px solid #1a1a1a',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#1a1a1a';
                                e.target.style.color = '#fff';
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#fff';
                                e.target.style.color = '#1a1a1a';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                            }}
                        >İptal</button>
                        <button
                            onClick={(e) => {
                                EditKaydet(e)
                            }}
                            style={{
                                padding: '12px 28px',
                                fontSize: '15px',
                                fontWeight: '600',
                                backgroundColor: '#edbc45',
                                color: '#1a1a1a',
                                border: 'none',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                                boxShadow: '0 2px 4px rgba(237, 188, 69, 0.3)'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#d4a63d';
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 4px 8px rgba(237, 188, 69, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#edbc45';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 2px 4px rgba(237, 188, 69, 0.3)';
                            }}
                        >Kaydet</button>
                    </div>
                </div>
            </div>

            <section className='misaifr_oda_view_datas'>
                <div className="top" style={{
                    backgroundColor: '#fff',
                    padding: '18px 24px',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    marginBottom: '20px',
                    border: '2px solid #edbc45'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '20px',
                        flexWrap: 'wrap'
                    }}>
                        <h1 style={{
                            fontSize: '22px',
                            fontWeight: '700',
                            color: '#1a1a1a',
                            margin: '0',
                            borderLeft: '4px solid #edbc45',
                            paddingLeft: '12px'
                        }}>Misafir ve Oda Giriş Verileri</h1>

                        <div style={{
                            display: 'flex',
                            gap: '12px',
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <label style={{
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#374151',
                                    whiteSpace: 'nowrap'
                                }}>Başlangıç:</label>
                                <input
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        Setdate1(e.target.value)
                                    }}
                                    value={date1}
                                    type="date"
                                    style={{
                                        padding: '8px 12px',
                                        fontSize: '13px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '6px',
                                        outline: 'none',
                                        transition: 'all 0.3s',
                                        width: '155px'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#edbc45'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>

                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <label style={{
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    color: '#374151',
                                    whiteSpace: 'nowrap'
                                }}>Bitiş:</label>
                                <input
                                    onChange={(e) => {
                                        Setdate2(e.target.value)
                                    }}
                                    value={date2}
                                    type="date"
                                    style={{
                                        padding: '8px 12px',
                                        fontSize: '13px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '6px',
                                        outline: 'none',
                                        transition: 'all 0.3s',
                                        width: '155px'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#edbc45'}
                                    onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                />
                            </div>

                            <button
                                style={{
                                    padding: '8px 18px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    backgroundColor: '#edbc45',
                                    color: '#1a1a1a',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: date1 !== "" && date2 !== "" ? 'pointer' : 'not-allowed',
                                    opacity: date1 !== "" && date2 !== "" ? '1' : '0.5',
                                    transition: 'all 0.3s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    boxShadow: '0 2px 4px rgba(237, 188, 69, 0.3)',
                                    whiteSpace: 'nowrap'
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (date1 !== "" && date2 !== "") {
                                        getElementsWithinDateRange(state, convertDateToMMDDYYYY(date1), convertDateToMMDDYYYY(date2))
                                    } else {
                                        alert("Lütfen Tarih Seçin!")
                                    }
                                }}
                                onMouseEnter={(e) => {
                                    if (date1 !== "" && date2 !== "") {
                                        e.target.style.backgroundColor = '#d4a63d';
                                        e.target.style.transform = 'translateY(-1px)';
                                        e.target.style.boxShadow = '0 4px 8px rgba(237, 188, 69, 0.4)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#edbc45';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 4px rgba(237, 188, 69, 0.3)';
                                }}
                            >
                                <i className="fa fa-search"></i>
                                Ara
                            </button>

                            <button
                                style={{
                                    padding: '8px 18px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    backgroundColor: '#1a1a1a',
                                    color: '#edbc45',
                                    border: '2px solid #edbc45',
                                    borderRadius: '6px',
                                    cursor: render_state.length > 0 ? 'pointer' : 'not-allowed',
                                    opacity: render_state.length > 0 ? '1' : '0.5',
                                    transition: 'all 0.3s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                    whiteSpace: 'nowrap'
                                }}
                                onClick={exportToExcel}
                                onMouseEnter={(e) => {
                                    if (render_state.length > 0) {
                                        e.target.style.backgroundColor = '#edbc45';
                                        e.target.style.color = '#1a1a1a';
                                        e.target.style.transform = 'translateY(-1px)';
                                        e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#1a1a1a';
                                    e.target.style.color = '#edbc45';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';
                                }}
                            >
                                <i className="fa fa-download"></i>
                                Excel
                            </button>

                            <button
                                style={{
                                    padding: '8px 18px',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    backgroundColor: '#fff',
                                    color: '#1a1a1a',
                                    border: '2px solid #e5e7eb',
                                    borderRadius: '6px',
                                    cursor: render_state.length > 0 ? 'pointer' : 'not-allowed',
                                    opacity: render_state.length > 0 ? '1' : '0.5',
                                    transition: 'all 0.3s',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                                    whiteSpace: 'nowrap'
                                }}
                                onClick={clear}
                                onMouseEnter={(e) => {
                                    if (render_state.length > 0) {
                                        e.target.style.backgroundColor = '#f3f4f6';
                                        e.target.style.borderColor = '#1a1a1a';
                                        e.target.style.transform = 'translateY(-1px)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = '#fff';
                                    e.target.style.borderColor = '#e5e7eb';
                                    e.target.style.transform = 'translateY(0)';
                                }}
                            >
                                <i className="fa fa-refresh"></i>
                                Sıfırla
                            </button>
                        </div>
                    </div>
                </div>

                {/* Trend Chart Section */}
                {render_state.length > 0 && (
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '20px',
                        marginTop: '20px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                        marginBottom: '20px'
                    }}>
                        <div style={{ height: '400px' }}>
                            <Line data={chartData} options={chartOptions} />
                        </div>
                    </div>
                )}

                <div className="bottom" style={{
                    backgroundColor: '#fff',
                    padding: '24px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    marginTop: '20px'
                }}>
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                        <table style={{
                            width: '100%',
                            tableLayout: 'fixed',
                            borderCollapse: 'separate',
                            borderSpacing: '0',
                            fontSize: '14px'
                        }}>
                            <thead>
                                <tr>
                                    <th style={{
                                        backgroundColor: '#edbc45',
                                        color: '#1a1a1a',
                                        padding: '14px 16px',
                                        textAlign: 'left',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        borderBottom: '3px solid #1a1a1a',
                                        width: '28%'
                                    }}>Başlangıç</th>
                                    <th style={{
                                        backgroundColor: '#edbc45',
                                        color: '#1a1a1a',
                                        padding: '14px 16px',
                                        textAlign: 'left',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        borderBottom: '3px solid #1a1a1a',
                                        width: '28%'
                                    }}>Bitiş</th>
                                    <th style={{
                                        backgroundColor: '#edbc45',
                                        color: '#1a1a1a',
                                        padding: '14px 16px',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        borderBottom: '3px solid #1a1a1a',
                                        width: '14%'
                                    }}>Misafir Sayısı</th>
                                    <th style={{
                                        backgroundColor: '#edbc45',
                                        color: '#1a1a1a',
                                        padding: '14px 16px',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        borderBottom: '3px solid #1a1a1a',
                                        width: '14%'
                                    }}>Oda Sayısı</th>
                                    <th style={{
                                        backgroundColor: '#edbc45',
                                        color: '#1a1a1a',
                                        padding: '14px 16px',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        borderBottom: '3px solid #1a1a1a',
                                        width: '8%'
                                    }}>Düzenle</th>
                                    <th style={{
                                        backgroundColor: '#edbc45',
                                        color: '#1a1a1a',
                                        padding: '14px 16px',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        fontSize: '13px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        borderBottom: '3px solid #1a1a1a',
                                        width: '8%'
                                    }}>Sil</th>
                                </tr>
                            </thead>
                            <tbody>
                                {render_state.length > 0 && render_state.map((item, index) => {
                                    console.log(render_state);

                                    if ((active_number - 1) * items_per_page <= index && index < active_number * items_per_page) {
                                        const isEven = index % 2 === 0;
                                        return <tr key={index} style={{
                                            backgroundColor: isEven ? '#fafafa' : '#fff',
                                            transition: 'all 0.2s'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#fff9e6';
                                            e.currentTarget.style.transform = 'scale(1.01)';
                                            e.currentTarget.style.boxShadow = '0 2px 8px rgba(237, 188, 69, 0.2)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = isEven ? '#fafafa' : '#fff';
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}>
                                            <td style={{
                                                padding: '14px 16px',
                                                borderBottom: '1px solid #e5e7eb',
                                                color: '#374151',
                                                fontWeight: '500',
                                                wordWrap: 'break-word'
                                            }}>{convertTo24HourAndDMY(item.date)}</td>
                                            <td style={{
                                                padding: '14px 16px',
                                                borderBottom: '1px solid #e5e7eb',
                                                color: '#374151',
                                                fontWeight: '500',
                                                wordWrap: 'break-word'
                                            }}>{index < render_state.length - 1 ? convertTo24HourAndDMY(render_state[index + 1].date) : ""}</td>
                                            <td style={{
                                                padding: '14px 16px',
                                                borderBottom: '1px solid #e5e7eb',
                                                color: '#1a1a1a',
                                                fontWeight: '700',
                                                textAlign: 'center',
                                                fontSize: '15px'
                                            }}>{item.misafir}</td>
                                            <td style={{
                                                padding: '14px 16px',
                                                borderBottom: '1px solid #e5e7eb',
                                                color: '#1a1a1a',
                                                fontWeight: '700',
                                                textAlign: 'center',
                                                fontSize: '15px'
                                            }}>{item.oda}</td>
                                            <td style={{
                                                padding: '14px 16px',
                                                borderBottom: '1px solid #e5e7eb',
                                                textAlign: 'center'
                                            }}>
                                                <button
                                                    onClick={() => {
                                                        openPopUp();
                                                        Set_current_edit_data({ misafir: item.misafir, oda: item.oda, date: item.date })
                                                    }}
                                                    style={{
                                                        padding: '8px 12px',
                                                        backgroundColor: '#edbc45',
                                                        color: '#1a1a1a',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        fontWeight: '600',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#d4a63d';
                                                        e.target.style.transform = 'scale(1.1)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = '#edbc45';
                                                        e.target.style.transform = 'scale(1)';
                                                    }}
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </button>
                                            </td>
                                            <td style={{
                                                padding: '14px 16px',
                                                borderBottom: '1px solid #e5e7eb',
                                                textAlign: 'center'
                                            }}>
                                                <button
                                                    onClick={(e) => {
                                                        function formatDate(dateString) {
                                                            const date = new Date(dateString);
                                                            const year = date.getFullYear();
                                                            const month = String(date.getMonth() + 1).padStart(2, "0");
                                                            const day = String(date.getDate()).padStart(2, "0");
                                                            const hours = String(date.getHours()).padStart(2, "0");
                                                            const minutes = String(date.getMinutes()).padStart(2, "0");
                                                            const seconds = String(date.getSeconds()).padStart(2, "0");
                                                            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.000`;
                                                        }
                                                        let sorguDate = formatDate(item.date)
                                                        let confirm = window.confirm("Bu veriyi silmek istediğinize emin misiniz?")
                                                        console.warn(render_state)
                                                        if (confirm) {
                                                            deleteData(sorguDate)
                                                        }
                                                    }}
                                                    style={{
                                                        padding: '8px 12px',
                                                        backgroundColor: '#1a1a1a',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        fontWeight: '600',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.3s'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.backgroundColor = '#dc2626';
                                                        e.target.style.transform = 'scale(1.1)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.backgroundColor = '#1a1a1a';
                                                        e.target.style.transform = 'scale(1)';
                                                    }}
                                                >
                                                    <i className="fa fa-times"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                    return null;
                                })}
                            </tbody>
                        </table>
                    </div>

                    {render_state.length > 0 && (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '16px',
                            padding: '12px 16px',
                            backgroundColor: '#f9fafb',
                            borderTop: '2px solid #edbc45',
                            flexWrap: 'wrap',
                            gap: '12px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>
                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a1a' }}>
                                    Göster:
                                </span>
                                <select
                                    value={items_per_page}
                                    onChange={(e) => {
                                        Set_items_per_page(Number(e.target.value));
                                        Set_active_number(1);
                                    }}
                                    style={{
                                        padding: '6px 12px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        border: '2px solid #edbc45',
                                        borderRadius: '6px',
                                        backgroundColor: '#fff',
                                        color: '#1a1a1a',
                                        cursor: 'pointer',
                                        outline: 'none'
                                    }}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                                <span style={{ fontSize: '14px', color: '#6b7280' }}>
                                    kayıt (Toplam: {render_state.length})
                                </span>
                            </div>

                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <button
                                    onClick={() => Set_active_number(active_number - 1)}
                                    disabled={active_number <= 1}
                                    style={{
                                        padding: '6px 12px',
                                        backgroundColor: active_number > 1 ? '#edbc45' : '#e5e7eb',
                                        color: active_number > 1 ? '#1a1a1a' : '#9ca3af',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: active_number > 1 ? 'pointer' : 'not-allowed',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    ‹
                                </button>

                                <span style={{
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#1a1a1a',
                                    padding: '6px 12px',
                                    backgroundColor: '#fff',
                                    border: '2px solid #edbc45',
                                    borderRadius: '6px',
                                    minWidth: '100px',
                                    textAlign: 'center'
                                }}>
                                    Sayfa {active_number} / {totalPages}
                                </span>

                                <button
                                    onClick={() => Set_active_number(active_number + 1)}
                                    disabled={active_number >= totalPages}
                                    style={{
                                        padding: '6px 12px',
                                        backgroundColor: active_number < totalPages ? '#edbc45' : '#e5e7eb',
                                        color: active_number < totalPages ? '#1a1a1a' : '#9ca3af',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: active_number < totalPages ? 'pointer' : 'not-allowed',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    ›
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}

const MapStateToProps = (state) => {
    return {
        misafir_oda: state.project_reducer.misafir_oda,
        temp_com_id: state.project_reducer.temp_com_id

    }
}

export default connect(MapStateToProps)(Misafir_oda_izleme)
